import { Button, Form, Col, Row } from 'antd';
import styled from 'styled-components';

interface STYLEDPROPS {
  lineSize?: number;
  statusSpreadsheet?: boolean;
  stepTwo?: boolean;
  isMobile?: boolean;
}

export const Step = styled(Form)`
  display: flex;
  flex-direction: column;
  width: 100%;
  .ant-row {
    margin-bottom: 0px;
  }
  .ant-form-item {
    margin-bottom: 8px;
  }
  .ant-form-item-label {
    padding: 0;
  }
  .ant-col {
    padding-left: 0;
    padding-right: 0;
  }
  .ant-input-search {
    width: 100% !important;
  }
`;

export const ColStyled = styled(Col)<STYLEDPROPS>`
  padding: ${props => !props.isMobile ? 20 : 0}px;
  ${(props) =>
    props.isMobile &&
    `
    .ant-picker,
    .ant-select,
    .ant-input {
      width: 100%;
    }
    .ant-picker,
    .ant-select:not(.ant-select-customize-input) .ant-select-selector,
    .ant-input {
      min-height: 44px;
    }
    .ant-select-single:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {
      height: 42px;
    }
    .ant-select-single .ant-select-selector .ant-select-selection-item,
    .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
      line-height: 42px;
    }
  `}
`;

export const ContentTitleProducers = styled.div<STYLEDPROPS>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 10px 5px 10px;
  padding-bottom: ${props => props.stepTwo ? 20 : 5}px;
`;

export const Line = styled.div<STYLEDPROPS>`
  background-color: #d9d9d9;
  height: 0.5px;
  width: ${props => props.lineSize}%;
`;

export const TitleProducers = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  margin-left: 8px;
  margin-right: 8px;
`;

export const searchContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 10px;
`;

export const ContentAside = styled.div<STYLEDPROPS>`
  display: flex;
  flex-direction: row;
  position:  ${props => !props.isMobile ? 'absolute' : 'relative'};
  width: 100%;
  align-items: center;
  justify-content: flex-end;
  z-index: 1;
  padding-right: ${props => !props.isMobile ? 20 : 0}px;
`;

export const ContentButton = styled.div<STYLEDPROPS>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: ${props => !props.isMobile ? 15 : 0 }px;
  margin-bottom: 15px;
  ${(props) =>
    props.isMobile &&
    `
    flex: 1;
    .ant-btn {
      width: 100%;
      height: 44px;
    }
  `}
`;

export const RowStyled = styled(Row)`
  position: relative;
  padding-left: 10px;
`;

export const ContentMobileButton = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;
`;

export const PhoneFilterBar = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
  margin-top: 4px;
`;

export const PhoneFilterEmpty = styled.span`
  flex: 1;
  min-width: 0;
  font-size: 12px;
  color: #8c8c8c;
`;

export const PhoneFilterButton = styled(Button)`
  flex: none;
  height: 44px;
`;

export const SheetActions = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 8px;

  .ant-btn {
    height: 44px;
  }
`;

export const MobileDivider = styled.hr`
  width: 100%;
  height: 1px;
  margin: 12px 0;
  background: #f0f0f0;
  border: none;
`;

export const MobileHint = styled.p`
  width: 100%;
  margin: 12px 0 0;
  font-size: 12px;
  color: #8c8c8c;
`;
